<template>
<div>
    <v-card>
      <v-toolbar dense class="toolbar" height="35px" color="grey lighten-3">     
        <img class="img-icons" src="@/assets/list_icon.png" id="icon" alt="User Icon" />          
        <span > Customer/Office Notes </span>
      </v-toolbar>  

          <v-textarea 
            class="text"
            :outlined="true"
            placeholder="Notes"
            :no-resize="true"
            :rows=2
            hide-details     
            :value="description" @change="v => description = v" 
          ></v-textarea>

    </v-card>

</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'    
  import { createHelpers } from 'vuex-map-fields';
  const { mapFields:mapInvoiceFields } = createHelpers({
    getterType: 'invoice/getField',
    mutationType: 'invoice/updateField',
  }); 
  export default {
    name: 'itinerary-detail-panel',
    computed: {        
      ...mapInvoiceFields(['selectedInvoice.description']),
    },  
    mixins: [validationMixin],  
    components: {
          
        },
    beforeMount() {
        this.context = { componentParent: this };
    },
    data: () => ({
      invoice: {
        id: null,
        date: null,        
      },
      
      context: null 
    }),
    created () {
      // let self = this
    },
    methods: {
       methodFromParent(cell) {
        alert("Parent Component Method from " + cell + "!");
      }
    }
  }
</script>

<style lang="scss">
 
</style>

<style scoped>
  .v-btn {
    margin: 0px 0;
    height:auto;
  }
  .img-icons {
    height: 24px;
  }
  .text {
    margin-bottom: 0px;
    padding: 5px;
    padding-bottom: 10px;
  }
  .menu-logo {
    height: 20px;
  }
  .table-remove-icon {
    min-width: auto
  }
  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
  }
</style>  
